export const getSamplesStream = (tags, guildIds=[0.0]) => {
    return new Promise((resolve, reject) => {
        if (window.isNFT) {
            resolve([]);
            return;
        }
        fetch('/samplesStream/' , {
            method: 'POST',
            body: JSON.stringify({andTags: tags, guildIds}),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then(resp => resp.json())
            .then(resp => {
                resolve(resp.ids);
            });
    });
}
